import { registrationCodeRequired } from "global";

export class RegisterUser {
    newUser: {
        eMail: string;
        userName: string;
        password: string;
        confirmPassword: string;
        name: string;
        firstName: string;
    };
    newAddress: {
        isCompany: boolean;
        tenantName: string;
        street: string;
        city: string;
        state: string;
        country: string;
        zipCode: string;
    };
    registrationCode?: string;

    constructor(
        newUser: {
            eMail: string,
            userName: string,
            password: string,
            confirmPassword: string,
            name: string,
            firstName: string,
        },
        newAddress: {
            isCompany: boolean,
            tenantName: string,
            street: string,
            city: string,
            state: string,
            country: string,
            zipCode: string
        }
    ) {
        this.newUser = newUser;
        this.newAddress = newAddress;
    }
    static empty(): RegisterUser {
        return {
            newUser: {
                eMail: "",
                userName: "",
                password: "",
                confirmPassword: "",
                name: "",
                firstName: "",
            },
            newAddress: {
                isCompany: true,
                tenantName: "",
                street: "",
                city: "",
                state: "",
                country: "",
                zipCode: ""
            },
            ...(registrationCodeRequired ? { registrationCode: "" } : {})
        };
    }
}